const authEndpoints = {
  csrf: '/auth/csrf',
  sessionLogin: '/auth/session/login',
  sessionLogout: '/auth/session/logout',
  changePassword: '/auth/password/change',
  entraLogin: '/auth/session/entra',
};

const conversationsEndpoints = {
  conversations: '/docs/conversations',
  pausedConversations: '/docs/conversations/paused',
};

const resultEndpoints = {
  updateResult: '/docs/results',
  getResults: '/docs/results',
  getOneResult: '/docs/results',
  retrySuggestions: '/docs/results',
  exportResult: '/export/results',
};

const feedbackEndpoints = {
  sendFeedback: '/docs/feedback',
};

const userEndpoints = {
  me: 'auth/users/me',
};

const dictationEndpoints = {
  cortiToken: '/docs/corti-token',
};

const anamnesesEndpoints = {
  getAnamneses: '/anamnesis',
  setAnamnesisSeen: '/anamnesis/seen',
  getVisitReasons: '/anamnesis/visit-reasons',
};

const languagesEndpoints = {
  getLanguages: '/docs/languages',
};

const recordingObjectionEndpoints = {
  recordingObjection: '/docs/recording-objection',
};

const exportStatusEndpoints = {
  exportStatus: '/export/status',
};

const preventionEndpoints = {
  preventionAlerts: '/prevention/alerts',
  influenzaVaccines: '/prevention/influenza/vaccines',
};

const immunizationEndpoints = {
  immunizations: '/immunizations',
};

const medatixxEndpoints = {
  scheinStatus: '/medatixx/schein/status',
  getPatientName: '/medatixx/patient-name',
  textBuildingBlocks: '/medatixx/text-building-blocks',
  openedPatient: '/medatixx/opened-patient',
};

const releaseNotesEndpoints = {
  releaseNotes: '/release-notes/list',
};

const featureFlagEndpoints = {
  featureFlags: '/feature-flags',
};

export const endpoints = {
  ...authEndpoints,
  ...userEndpoints,
  ...conversationsEndpoints,
  ...resultEndpoints,
  ...dictationEndpoints,
  ...feedbackEndpoints,
  ...anamnesesEndpoints,
  ...languagesEndpoints,
  ...recordingObjectionEndpoints,
  ...exportStatusEndpoints,
  ...preventionEndpoints,
  ...immunizationEndpoints,
  ...medatixxEndpoints,
  ...releaseNotesEndpoints,
  ...featureFlagEndpoints,
};
